module.exports = __webpack_public_path__ + "img/noauth.f1e8dbcc.png";